import { validateProcedure } from './procedureValidator';
import { failedOutcome, resolveFood } from './outcome';
import type { FoodInput, FoodTestOutcome, ProcedureState } from './types';

export function getDcpipOutcome(food: FoodInput, procedure: ProcedureState): FoodTestOutcome {
  const validation = validateProcedure('vitamin-c', procedure);
  if (!validation.valid) return failedOutcome('vitamin-c', validation.errors.join(' '));

  const sample = resolveFood(food);
  const level = sample.composition.vitaminC;
  const dropsRequired = level > 0 ? Math.max(1, Math.ceil(12 / level)) : Number.POSITIVE_INFINITY;
  const dropsAdded = procedure.steps.filter((step) => step.action === 'add-food-drop').length;
  const decolourised = level > 0 && dropsAdded >= dropsRequired;
  const category = decolourised ? (level >= 0.5 ? 'strong-positive' : 'positive') : level > 0 && dropsAdded > 0 ? 'weak-positive' : 'negative';

  return {
    test: 'vitamin-c',
    category,
    observation: decolourised
      ? `Blue DCPIP becomes colourless after ${dropsAdded} drops of sample.`
      : level > 0
        ? `DCPIP is still blue after ${dropsAdded} drops; add more sample dropwise (about ${dropsRequired} drops are expected for this reference sample).`
        : 'DCPIP remains blue after the sample is added; vitamin C is not detected.',
    colour: decolourised ? '#eaf5f1' : '#2475bd',
    colourName: decolourised ? 'colourless' : 'blue',
    precipitate: false,
    emulsion: false,
    dropsRequired: Number.isFinite(dropsRequired) ? dropsRequired : undefined,
    dropsAdded,
    reasoning: 'Vitamin C reduces blue DCPIP to a colourless form. Fewer drops needed to remove the blue colour indicate a higher relative vitamin C concentration.',
    warnings: validation.warnings,
  };
}